<script setup>
import { useGlobalHeader } from '../composable/useGlobalHeader.js'
const { addParams } = useGlobalHeader()
const props = defineProps({
  text: { type: String, default: null },
  link: { type: String, default: null },
  icon: { type: String, default: null }
})
</script>

<template>
  <a
    :href="addParams(props.link, 'header')"
    class="recommendItem"
  >
    <figure
      v-if="props.icon"
      class="image"
    >
      <img
        :src="props.icon"
        width="16"
        height="16"
        alt=""
        loading="lazy"
      >
    </figure>
    <p class="text">{{ props.text }}</p>
  </a>
</template>

<style lang="scss" scoped>
.recommendItem {
  display: flex;
  align-items: center;
  gap: 3px;
  padding: 7px 5px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 2px 0 rgba(#000, .15);
  .image {
    width: 16px;
    height: 16px;
    img {
      height: 100%;
      vertical-align: baseline;
    }
  }
  .text {
    color: #3569c0;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: -1px;
    white-space: nowrap;
    line-height: 16px;
  }
  @media screen and (min-width: 830px) {
    height: 100%;
    transition: box-shadow .2s ease-in-out;
    &:hover {
      box-shadow: 0 2px 6px 0 rgba(#000, .45);
    }
    .text {
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 0;
    }
  }
}
</style>
